/* eslint-disable max-len */
import CardanoQuestion from 'images/coin-pages/questions/cardano.svg'

import { ICoinPageData } from '../types'

export const adaPage: ICoinPageData = {
  title: 'coin_26',
  description: 'coin_27',
  metaTitle: 'ada_loan_meta_title',
  metaDescription: 'ada_loan_meta_desc',
  calculatorTitle: 'borrow_against_ada',
  h1: (t) => (
    <span dangerouslySetInnerHTML={{ __html: t('get_ada_loan') }} />
  ),
  questionsBlock: {
    image: CardanoQuestion,
    questions: [
      {
        title: 'coin_29',
        answer: 'coin_30',
      },
      {
        title: 'coin_31',
        answer: 'coin_32',
      },
      {
        title: 'coin_33',
        answer: 'coin_34',
      },
      {
        title: 'coin_35',
        answer: 'coin_36',
      },
    ],
  },
  whatIs: {
    text: [],
    learnMoreTitle: 'learn_more_about_name_lending',
    paragraphs: [
      {
        title: 'coin_37',
        text: ['coin_40'],
      },
      {
        title: 'coin_38',
        text: ['coin_41', 'coin_42', 'coin_43', 'coin_44'],
      },
      {
        title: 'coin_39',
        text: ['coin_45', 'coin_46', 'coin_47', 'coin_48'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/how-to-get-a-cardano-loan/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2022/02/%D0%BE%D0%B1%D0%BB%D0%BA.png',
        imageAlt: 'Cardano (ADA) review 5',
      },
      {
        link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2021/08/integration-52CR_LQ.png',
        imageAlt: 'Cardano (ADA) review 6',
      },
      {
        link: 'https://coinrabbit.io/blog/guide-to-short-selling-with-coinrabbit-bear-market-loans/',
        image: 'https://coinrabbit.io/blog/wp-content/uploads/2021/06/Bear-loans.png',
        imageAlt: 'Cardano (ADA) review 7',
      },
    ],
  },
}
